import moment from "moment";
import { KRONOS_UNITS, SECONDS_IN_A_DAY } from "../../constants";
import Timer_Entity from "./timer";
export default class Timer extends Timer_Entity {
  static fromList(timersJSON: unknown): Array<Timer> {
    const timers: Timer[] = [];
    if (timersJSON)
      Array.isArray(timersJSON) &&
        timersJSON.forEach((timerJSON) => {
          timers.push(new Timer(timerJSON));
        });
    return timers;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  start(trimForDate?: string) {
    if (trimForDate) {
      const trim = moment(trimForDate);
      const start = moment(this.startDateUTC);
      const end = moment(this.endDateUTC);

      if (trim.isBetween(start, end, "days", "[]")) {
        if (start.isSame(trim, "day")) return this.startDateUTC;
        if (start.isBefore(trim, "day")) return trim.startOf("day").format();
      }
    }

    return this.startDateUTC;
  }

  end(trimForDate?: string) {
    if (!this.endDateUTC || this.endDateUTC === "0001-01-01T00:00:00Z")
      return undefined;
    if (trimForDate) {
      const trim = moment(trimForDate);
      const start = moment(this.startDateUTC);
      const end = moment(this.endDateUTC);

      if (trim.isBetween(start, end, "days", "[]")) {
        if (end.isSame(trim, "day")) return this.endDateUTC;
        if (end.isAfter(trim, "day")) return trim.endOf("day").format();
      }
    }

    return this.endDateUTC;
  }

  splice(forDate?: string) {
    const seconds = moment(this.end(forDate)).diff(
      this.start(forDate),
      "second"
    );
    const s = seconds % 60;
    const m = Math.floor(seconds / 60) % 60;
    const h = Math.floor(seconds / 3600);

    const ret = [];
    ret.push(`${h}`);

    ret.push(`${m}`);

    ret.push(`${s}`);

    return ret;
  }

  offset(forDate?: string) {
    const startOfDay = moment(this.startDateUTC).startOf("day");
    let startDateUTC = moment(this.startDateUTC);
    if (forDate && !startDateUTC.isSame(moment(forDate), "day")) {
      startDateUTC = startOfDay;
    }
    const d = startDateUTC.diff(startOfDay, "second");
    const percent = (d / SECONDS_IN_A_DAY) * 100;
    return `${percent}%`;
  }

  width(forDate?: string) {
    const seconds = this.durationInSeconds(forDate);
    const percent = (seconds / SECONDS_IN_A_DAY) * 100;
    return `${percent}%`;
  }

  durationInSeconds(forDate?: string) {
    const start = moment(this.start(forDate));
    const end = moment(this.end(forDate));
    const seconds = end.diff(start, "second");

    return seconds;
  }

  durationLabel(forDate?: string) {
    const splice = this.splice(forDate);
    let ret = "";
    splice.forEach((s, i) => (ret += `${s}${KRONOS_UNITS[i]} `));
    return ret;
  }

  completed() {
    return this.end() !== undefined;
  }

  label(forDate?: string): string {
    const start = moment(this.start(forDate));
    let end;
    if (this.end(forDate)) end = moment(this.end(forDate));
    return `${start.format("hh:mm:ss A")}${
      end ? ` : ${end.format("hh:mm:ss A")}` : ""
    } (${this.durationLabel(forDate)})`;
  }
}
